import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useApi } from '../store/auth.store'

export interface TwoFactorStatus {
  enabled: boolean
  remainingBackupCodes: number
}

export interface TwoFactorSetup {
  secret: string
  otpauthUrl: string
  qrCodeDataUrl: string
}

export function useTwoFactorStatus() {
  const api = useApi()
  return useQuery<TwoFactorStatus>({
    queryKey: ['2fa-status'],
    queryFn: () => api.get<TwoFactorStatus>('/auth/2fa/status'),
  })
}

export function useSetup2FA() {
  const api = useApi()
  return useMutation<TwoFactorSetup, Error, void>({
    mutationFn: () => api.post<TwoFactorSetup>('/auth/2fa/setup', {}),
  })
}

export function useVerify2FA() {
  const api = useApi()
  const qc = useQueryClient()
  return useMutation<{ success: boolean; backupCodes: string[] }, Error, string>({
    mutationFn: (code: string) => api.post('/auth/2fa/verify', { code }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['2fa-status'] })
    },
  })
}

export function useDisable2FA() {
  const api = useApi()
  const qc = useQueryClient()
  return useMutation<{ success: boolean; message: string }, Error, string>({
    mutationFn: (code: string) => api.post('/auth/2fa/disable', { code }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['2fa-status'] })
    },
  })
}
